/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";

export default class LoadingModal extends BaseCom {

    render() {
        return this.wrapModal(<>
            <h1>Loading editor...</h1>
        </>, null);
    }
}